import html2canvas from 'html2canvas-pro';
import { ElLoading } from 'element-plus';
import { config } from '../config';
import { acceptImageFormats } from '../config/index';
export default {
  components: {},
  data() {
    return {
      // logo start
      downloadTxt: '下载图片',
      w: 'auto',
      h: 'auto',
      logoType: '1',
      logoStyle: {
        fontSize: 26,
        borderRadius: 0,
        color: 'red',
        width: 0,
        height: 37,
        imgwidth: 0,
        imgheight: 37,
        logoTxt: '',
        opacity: 1,
        bgShadow: 3,
        shadowColor: 'rgba(132, 128, 128, 1)',
        family: 'PingFang SC',
        bg: 'transparent',
        rotate: 0,
        scale: 1,
        logoImg: null
      },
      form: {
        width: 200,
        rongcuoA: 'H',
        errorCorrectionLevel: "H",
        // 可选，容错级别，值有 L（低）、M（中）、Q（高）、H（最高），默认为H
        type: "image/jpeg",
        // 可选，生成的二维码类型
        quality: 100,
        // 可选，二维码质量
        margin: 5,
        // 可选，二维码留白边距1
        color: {
          dark: "#000000",
          // 可选，前景色，格式必须是十六进制的，如果不是则会报错，比如：blue或rgb(255,245,255)等
          light: "#ffffff" // 可选，背景色，格式同上
        }
      },
      dialogImageUrl: null,
      dialogVisible: true,
      disabled: false,
      // logo end
      radioA: '2',
      acceptImageFormats,
      baseUrl: config.baseUrl,
      fileList: [],
      options: {
        quality: 100,
        format: '',
        divide: 3,
        cdn: false,
        cdnDir: ''
      }
    };
  },
  computed: {
    // uploadOptions() {
    //   const { quality, format, cdn, cdnDir } = this.options;
    //   return {
    //     quality: quality,
    //     format: format,
    //     cdn: cdn || '',
    //     cdnDir,
    //   }
    // }
  },
  watch: {
    // 'logoStyle.logoTxt': function (newVal) {
    //   let len = newVal.length
    //   this.logoStyle.width = len * 26

    // },
    'logoStyle.rotate': function (newVal) {
      // const len = this.logoStyle.logoTxt.length
      // this.logoStyle.width = len * newVal
      // this.logoStyle.height = newVal * 1.1

      const wh = this.getRotatedSize(this.$refs.logoSpan, newVal);
      this.w = `${wh.width}px`;
      this.h = `${wh.height}px`;
    }
  },
  methods: {
    // 获取旋转后的图片宽高
    getRotatedSize(img, angle) {
      // 获取图片原始宽度和高度
      var width = img.naturalWidth;
      var height = img.naturalHeight;

      // 计算旋转后的新宽度和高度
      var radians = angle * (Math.PI / 180);
      var cos = Math.abs(Math.cos(radians));
      var sin = Math.abs(Math.sin(radians));
      return {
        width: width * cos + height * sin,
        height: height * cos + width * sin
      };
    },
    // logo start
    onChange(file) {
      console.log(file, 'change');
      const img = new Image();
      img.onload = () => {
        console.log('Width:', img.width, 'Height:', img.height);
        this.logoStyle.imgwidth = img.width;
        this.logoStyle.imgheight = img.height;
        this.logoStyle.logoImg = file.url;
      };
      img.src = file.url;
    },
    setLogoTxtFn() {
      console.log('setLogoTxtFn');
    },
    onSuccess(response) {
      console.log(response, '文件上传成功回调---');
    },
    onSuccess2(response) {
      console.log(response, '文件上传成功回调---');
      if (response && response.data && response.data.images && response.data.images.length > 0) {
        this.logoStyle.logoImg = response.data.images[0];
      }
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      console.log(file);
      const img = new Image();
      img.onload = () => {
        console.log('Width:', img.width, 'Height:', img.height);
        this.w = img.width;
        this.h = img.height;
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      };
      img.src = file.url;
    },
    handleDownload(file) {
      console.log(file);
    },
    // logo end
    downloadAll() {
      this.disabledBtn = true;
      const that = this;
      const loadingss = ElLoading.service({
        lock: true,
        text: '图片下载中。。。',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      html2canvas(this.$refs.logoSpan, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: this.logoStyle.bg
      }).then(canvas => {
        const imageURL = canvas.toDataURL("image/png");
        // 创建一个下载链接
        const link = document.createElement('a');
        link.download = '压图-添加水印.png'; // 设置下载文件名
        link.href = imageURL;
        link.click(); // 触发下载
        setTimeout(() => {
          loadingss.close();
          that.disabledBtn = false;
        }, 600);
      });
    },
    clearFileList() {
      this.fileList = [];
    }
  }
};